var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.276042,
    y: 0.276042,
    width: 23.1875,
    height: 23.1875,
    rx: 4.14062,
    fill: "#242424",
    stroke: "#454545",
    strokeWidth: 0.552083
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.977 8.86295C16.7549 8.74378 16.2891 8.6192 15.6554 9.06336L14.8591 9.6267C14.7995 7.94211 14.0683 7.28128 12.2916 7.28128H9.04161C7.18911 7.28128 6.46869 8.0017 6.46869 9.8542V14.1875C6.46869 15.4334 7.14577 16.7604 9.04161 16.7604H12.2916C14.0683 16.7604 14.7995 16.0996 14.8591 14.415L15.6554 14.9784C15.9912 15.2167 16.2837 15.2925 16.5166 15.2925C16.717 15.2925 16.8741 15.2329 16.977 15.1788C17.1991 15.065 17.5729 14.7563 17.5729 13.9817V10.06C17.5729 9.28545 17.1991 8.9767 16.977 8.86295ZM11.4791 11.685C10.9212 11.685 10.4608 11.23 10.4608 10.6667C10.4608 10.1034 10.9212 9.64836 11.4791 9.64836C12.037 9.64836 12.4974 10.1034 12.4974 10.6667C12.4974 11.23 12.037 11.685 11.4791 11.685Z",
    fill: "#D7D7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.9e70cf10c84aa3d3871ceddd34f38347.svg";
export { ForwardRef as ReactComponent };